import React from 'react'
import {
  IndexLayoutContent,
  IndexLayoutExtraProps,
  IndexLayoutHeaderLink,
  useQueryParams,
  useSignOut,
} from '@sketch/modules-common'
import { Button, Link } from '@sketch/components'
import { SKETCH_WEBSITE } from '@sketch/env-config'
import {
  StyledExclamationMarkIcon,
  StyledPanel,
  PanelTitle,
  PanelBody,
  Description,
  ErrorMessageContainer,
  PanelFooter,
  BottomText,
} from './SsoSignInErrorView.styles'
import {
  createLayoutPortal,
  workspaceSidebarLayoutSymbols,
} from '@sketch/utils'

interface SsoSignInErrorViewProps extends IndexLayoutExtraProps {}

const HeaderPortal = createLayoutPortal(workspaceSidebarLayoutSymbols.header)

export const SsoSignInErrorView = (props: SsoSignInErrorViewProps) => {
  const signOut = useSignOut({
    revokeSessions: 'none',
    reason: 'SSO Error',
  })
  const { message } = useQueryParams<'SSO_ERROR'>()

  return (
    <IndexLayoutContent center>
      <HeaderPortal>
        <IndexLayoutHeaderLink />
      </HeaderPortal>
      <StyledPanel>
        <StyledExclamationMarkIcon width="64" height="64" />
        <PanelTitle>Configuration Error</PanelTitle>
        <PanelBody>
          <Description>
            We could not sign you into the workspace. Please, contact the
            Workspace administrator to resolve this issue:
          </Description>
          <ErrorMessageContainer>
            <p>{message}</p>
          </ErrorMessageContainer>
        </PanelBody>
        <PanelFooter>
          <Button variant="primary" onClick={() => signOut()} fill>
            Sign Out
          </Button>
        </PanelFooter>
      </StyledPanel>
      <BottomText textStyle="copy.tertiary.standard.D">
        <span>
          Need Help?{' '}
          <Link
            variant="primary"
            href={`${SKETCH_WEBSITE}/support/`}
            target="_blank"
            external
            isUnderlined
          >
            Get in touch
          </Link>{' '}
        </span>
      </BottomText>
    </IndexLayoutContent>
  )
}
